<div class="notification-title display-flex align-items-center no-wrap" mat-dialog-title>
  {{ 'Custom ' + title }}
</div>

<mat-dialog-content>
  <div class="notification-modal">
    <div class="display-flex flex-column grid-gap-16">
      <div class="flex-1">
        <div class="display-flex grid-gap-16 align-items-end">
          <!-- notifyOn / remindOn -->
          <ng-container *ngIf="data.fieldType === 'notifyOn' || data.fieldType === 'remindOn'">
            <div class="flex-50 remind-field">
              <app-input
                [labelCss]="'nowrap pre-label'"
                [containerCss]="'display-flex flex-column grid-gap-4'"
                [markAsInvalid]="formSubmitted && daysControl.invalid"
                attrPlaceholder="Enter number of days"
                [formControl]="daysControl"
                [attrLabel]="title"></app-input>
            </div>
            <div class="flex-50 remind-field">
              <app-radio-button-dropdown
                class="flex-grow-1"
                [containerCss]="'w-100'"
                [items]="beforeAfterItems"
                [formControl]="beforeAfterControl"
                [allowClear]="false"
                [allowSearch]="false"
                [autoSortList]="false"
                [showValidationError]="false"
                [labelRequired]="false"
                attrAppendTo="body"></app-radio-button-dropdown>
            </div>
          </ng-container>

          <!-- thenRemindOn -->
          <ng-container *ngIf="data.fieldType == 'thenRemindOn'">
            <div class="flex-1">
              <app-input
                [labelCss]="'nowrap pre-label'"
                [containerCss]="'display-flex flex-column grid-gap-4'"
                [markAsInvalid]="formSubmitted && daysControl.invalid"
                attrPlaceholder="Enter number of days"
                [formControl]="daysControl"
                [attrLabel]="'Notification frequency'"></app-input>
            </div>
          </ng-container>

          <!-- until -->
          <ng-container *ngIf="data.fieldType == 'until'">
            <div class="flex-1">
              <app-input
                [labelCss]="'nowrap pre-label'"
                [containerCss]="'display-flex flex-column grid-gap-4'"
                [markAsInvalid]="formSubmitted && daysControl.invalid"
                attrPlaceholder="Enter number of times"
                [formControl]="daysControl"
                [attrLabel]="title"></app-input>
            </div>
          </ng-container>

          <ng-container *ngIf="data.fieldType === 'dueDate'">
            <div class="w-100 display-flex flex-column grid-gap-4">
              <div class="label-height display-flex align-items-center">
                <label class="label-required ng-star-inserted">Due</label>
              </div>
              <div class="w-100 display-flex grid-gap-16">
                <div class="flex-40">
                  <app-input
                    class="flex-1"
                    [labelCss]="'nowrap pre-label'"
                    [containerCss]="'display-flex flex-column grid-gap-4'"
                    [markAsInvalid]="formSubmitted && daysControl.invalid"
                    attrPlaceholder="Enter number of days"
                    [formControl]="daysControl"></app-input>
                </div>
                <div class="flex-60">
                  <app-radio-button-dropdown
                    class="flex-1"
                    [containerCss]="'w-100'"
                    [items]="beforeAfterItems"
                    [formControl]="beforeAfterControl"
                    [dividerPosition]="dividerPosition"
                    [allowClear]="false"
                    [allowSearch]="false"
                    [autoSortList]="false"
                    [showValidationError]="false"
                    [labelRequired]="false"
                    attrAppendTo="body"></app-radio-button-dropdown>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="display-flex justify-content-space-between w-100">
    <button mat-stroked-button color="primary" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()">Done</button>
  </div>
</mat-dialog-actions>
